import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/map';

import { AuthenticationService,EncryptionService } from '../services';

@Injectable()
export class PureGuard implements CanActivate {
  
  constructor(private router: Router,private encryptionService:EncryptionService) {}

  canActivate() {
    if (
      (!this.encryptionService.getData('currentUser')) && 
      (!localStorage.getItem('authorizedRole'))
    ) {
      return true;
    }
    this.router.navigate(['/pages/dashboard']);
    return false;
  }
  
  /*
  constructor (
	private router: Router,
	private authService: AuthenticationService
  ) {}
  
  canActivate (
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
	return this.authService.isLoggedIn
      .take(1)
      .map((isLoggedIn: boolean) => {
        if (isLoggedIn) {
          this.router.navigate(['/pages/dashboard']);
          return false;
        }
        return true;
      });
  }
  */
}


// WEBPACK FOOTER //
// ./src/app/guards/pure.guard.ts